import type { FC } from "react";
import type { IconType } from "react-icons";
import { BiCommentDetail } from "react-icons/bi";
import { BsExclamationSquare } from "react-icons/bs";
import { MdOutlinePoll } from "react-icons/md";
import { PiQuotesBold } from "react-icons/pi";

import { TbBallFootball, TbRectangleVerticalFilled } from "react-icons/tb";
import { colours } from "../../../../styles/colours.constants";
import type { PostType } from "../../../../types/post.types";
import { PostType as PostTypeEnum } from "../../../../types/post.types";
import Icon from "../../../icon/icon";
import * as CSS from "./post-header.styles";

type CardType = "yellow" | "2Yellow" | "red";

type PostHeaderProps = {
	type: PostType;
	time: string | null;
	logo?: string;
	cardType?: CardType;
};

const getIcon = (type: PostType): IconType => {
	switch (type) {
		case PostTypeEnum.VAR:
		case PostTypeEnum.PENALTY:
			return TbBallFootball;
		case PostTypeEnum.KEY_MOMENT:
			return BsExclamationSquare;
		case PostTypeEnum.GOAL:
			return TbBallFootball;
		case PostTypeEnum.FAN_COMMENT:
			return PiQuotesBold;
		case PostTypeEnum.CARD:
			return TbRectangleVerticalFilled;
		case PostTypeEnum.POLL:
		case PostTypeEnum.POLL_RESULT:
			return MdOutlinePoll;
		default:
			return BiCommentDetail;
	}
};

const getTimeColour = (type: PostType): string => {
	switch (type) {
		case PostTypeEnum.VAR:
		case PostTypeEnum.PENALTY:
			return colours.red;
		default:
			return colours.black;
	}
};

const getCardColour = (cardType?: CardType) => {
	if (cardType === "red") {
		return colours.red;
	}

	return colours.yellow;
};

const PostHeader: FC<PostHeaderProps> = ({ time, type, logo, cardType }) => {
	return (
		<CSS.Container>
			<CSS.IconTitle>
				<Icon
					icon={getIcon(type)}
					color={
						type === PostTypeEnum.CARD ? getCardColour(cardType) : colours.black
					}
				/>
				{time && <CSS.Minute $color={getTimeColour(type)}>{time}</CSS.Minute>}
			</CSS.IconTitle>
			{logo && <img width={42} src={logo} alt="Team logo" />}
		</CSS.Container>
	);
};

export default PostHeader;
